import script from "./ExperienciaProfesional.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExperienciaProfesional.vue?vue&type=script&setup=true&lang=ts"

import "./ExperienciaProfesional.vue?vue&type=style&index=0&id=5dade13c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dade13c"]])

export default __exports__